import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { AppointmentTypeService } from '../appointment-type.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { LookupService } from 'src/app/services/lookup.service';
import { BillChargeDetailComponent } from '../../../hospital-setting/bill-charge/bill-charge-detail/bill-charge-detail.component';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { IAppointmentType } from '../iappointment-type';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-appointment-detail',
  standalone: true,
  imports: [CommonModule, MaterialModule, TablerIconsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './appointment-detail.component.html',
  styleUrl: './appointment-detail.component.scss'
})
export class AppointmentDetailComponent implements OnInit {
  appointmentForm: FormGroup;
  isEdit: boolean;
  listofBillCharge: CommonDropDown[];
  billCharges$: Observable<CommonDropDown[]>;
  private destroy$ = new Subject<void>();
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _appointmentTypeService: AppointmentTypeService,
    private _formbuilder: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private _lookupService: LookupService,
    private dialogRef: MatDialogRef<AppointmentDetailComponent>,
    private dialog: MatDialog,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { appointmenttype: IAppointmentType, isEdit: boolean },
  ) {
    this.isEdit = _data?.isEdit;
  }
  ngOnInit(): void {
    this.appointmentForm = this._formbuilder.group({
      name: [this._data?.appointmenttype?.name, [Validators.required, Validators.maxLength(100)]],
      billChargeId: [this._data?.appointmenttype?.billChargeId, [Validators.required]]
    })
    this._lookupService.billcharges$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((billcharge: CommonDropDown[]) => {
        this.listofBillCharge = billcharge;
      });
  }
  onSaveAppointmentType() {
    const data = this.appointmentForm.getRawValue();
    this._appointmentTypeService.createAppointmentType(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.APPOINTMENT_TYPE')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }
  onUpdateAppointmentType() {
    const data = {
      id: this._data?.appointmenttype?.id,
      ...this.appointmentForm.getRawValue()
    };

    this._appointmentTypeService.updateAppointmenttype(data).subscribe((response) => {

      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.APPOINTMENT_TYPE')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    });
  }

  addBillCharge() {
    this.dialog.open(BillChargeDetailComponent, {
      maxWidth: '70vh',
      width: '90%',
    }).afterClosed().subscribe((response) => {
      if (response.result) {
        this.billChargeLookup();
        this.appointmentForm.get('billChargeId')?.setValue(response.result.id);

      }
    });

  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  private billChargeLookup() {
    this._lookupService.getBillCharge().pipe(take(1)).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}